// * UIDs
export const FINAL_GRADE_CALCULATION_METHODOLOGY_UID =
  "finalGradeCalculationMethodology";
export const FINAL_GRADE_CALCULATION_STANDARD_SET_UID =
  "finalGradeCalculationStandardSet";
export const FINAL_GRADE_CALCULATION_STANDARD_SET_LIST_UID =
  "finalGradeCalculationStandardSetList";
export const FINAL_GRADE_CALCULATION_GRADE_SCALE_UID =
  "finalGradeCalculationGradeScale";
